"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function AnalisiMatematica() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.3
  });
  return <section id="analisi-matematica" className="dark bg-background text-foreground relative w-full min-h-screen flex flex-col lg:flex-row overflow-hidden">
      {}
      <div className="w-full lg:w-[60%] relative h-[50vh] lg:h-screen sticky top-0 flex items-center justify-center overflow-hidden bg-background border-b lg:border-b-0 lg:border-r border-primary/20">
        {}
        <div className="absolute inset-0 opacity-10 pointer-events-none" style={{
        backgroundImage: `linear-gradient(var(--border) 1px, transparent 1px), linear-gradient(90deg, var(--border) 1px, transparent 1px)`,
        backgroundSize: "40px 40px"
      }} />

        {}
        <div className="relative w-[120%] max-w-4xl aspect-square animate-[spin_240s_linear_infinite] opacity-70 mix-blend-screen flex items-center justify-center">
          {}
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1591789/img/holographic_cis_market_heat_map.png" alt="Mappa Olografica Zone di Calore CSI" className="w-full h-full object-contain filter drop-shadow-[0_0_20px_rgba(220,20,60,0.4)]" />
        </div>

        {}
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,transparent_20%,var(--background)_80%)] pointer-events-none" />
      </div>

      {}
      <div className="hidden lg:block absolute left-[60%] top-0 bottom-0 w-[2px] bg-primary shadow-[0_0_15px_var(--primary)] z-20 transform -translate-x-1/2" />
      <div className="block lg:hidden absolute top-[50vh] left-0 right-0 h-[2px] bg-primary shadow-[0_0_15px_var(--primary)] z-20 transform -translate-y-1/2" />

      {}
      <div className="w-full lg:w-[40%] flex flex-col justify-center px-8 py-24 lg:px-16 xl:px-24 z-10 bg-background relative">
        {}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-3/4 h-3/4 bg-primary/5 blur-[100px] rounded-full pointer-events-none" />

        <div ref={ref} className={`relative transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-foreground leading-[1.1] mb-8 tracking-tight uppercase">
            Non tiriamo freccette al buio.
          </h2>
          
          <div className="w-12 h-1 bg-primary mb-8 shadow-[0_0_10px_var(--primary)]" />

          <p className="font-sans text-lg md:text-xl text-muted-foreground leading-relaxed max-w-md">
            La vera espansione non è marketing, è matematica. Sovrapponiamo strati di intelligence per dirti dove il prodotto ha praterie libere.
          </p>
        </div>
      </div>
    </section>;
}